<template>
  <div class="footer">
    <div class="container">
      <nav class="footer-nav">
        <ul>
          <li>
            <h5>
              <a :href="$t('footer.privacy-policy-url')" target="_blank">
                {{ $t('footer.privacy-policy') }}
              </a>
            </h5>
          </li>
          <li>
            <h5>
              <a :href="$t('footer.legal-notice-url')" target="_blank">
                {{ $t('footer.legal-notice') }}
              </a>
            </h5>
          </li>
          <li>
            <h5>
              <a :href="$t('footer.cookies-url')" target="_blank">{{
                $t('footer.cookies')
              }}</a>
            </h5>
          </li>
          <li>
            <h5>
              <a :href="$t('footer.imprint-url')" target="_blank">
                {{ $t('footer.imprint') }}
              </a>
            </h5>
          </li>
          <li>
            <h5>
              <a :href="$t('footer.supply-chain-url')" target="_blank">{{
                $t('footer.supply-chain')
              }}</a>
            </h5>
          </li>
        </ul>
      </nav>
      <p class="copyright-text">
        {{ $t('footer.copyright') }}
        <br />
        <br />
        {{ $t('footer.version') }} {{ applicationVersion }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modeName: process.env.VUE_APP_MODE_NAME,
      // eslint-disable-next-line no-undef
      applicationVersion: APPLICATION_VERSION
    }
  }
}
</script>

<style lang="scss" scoped></style>
